import { render, staticRenderFns } from "./addArticle.vue?vue&type=template&id=1953e530&scoped=true"
import script from "./addArticle.vue?vue&type=script&lang=js"
export * from "./addArticle.vue?vue&type=script&lang=js"
import style0 from "./addArticle.vue?vue&type=style&index=0&id=1953e530&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1953e530",
  null
  
)

export default component.exports